/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiConfig} from '../config/api-config';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';

@Injectable({providedIn: 'root'})
export class ReachEstimateApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  save(lineItemId: string | null, data: any, params: Record<string, any> = {}): Observable<any> {
    const path = lineItemId ? ['reachestimate', lineItemId] : ['reachestimate'];
    return this.client.request({
      method: 'POST',
      url: this.apiConfig.getVersionedUri(path),
      params,
      body: data
    });
  }

  getDiagnostics(): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['reachestimate', 'diag'])
    });
  }
}
